export default {
  pageTitles: {
    "/dashboard": "Dashboard",
    "/changes": "Eventos detectados",
    "/sources": "Fuentes Monitorizadas",
    "/portfolio": "Portfolio",
    "/alerts": "Avisos por correo",
    "/admin": "Usuarios",
    "/changelog": "Historial de versiones",
    "/profile": "Mi perfil",
    "/notifications": "Avisos",
    "/onboarding": "Configuración inicial",
    "/products": "Mis Productos",
    "/competitors": "Competidores",
    "/history": "Histórico",
    "/trends": "Tendencia de precios",
    "/radar": "Radar Regulatorio",
    "/upgrade": "Planes y suscripción",
    "/prices": "Comparador de Precios",
    "/calendar": "Calendario",
    "/reports": "Informes",
  },
  time: {
    now: "Ahora mismo",
    minAgo: "Hace {n} min",
    hourAgo: "Hace {n}h",
    yesterday: "Ayer",
    daysAgo: "Hace {n} días",
  },
  topbar: {
    openMenu: "Abrir menú",
    viewTutorial: "Ver tutorial de inicio",
    notifications: "Avisos",
    markAllRead: "Marcar todo leído",
    noNotifications: "Sin avisos nuevos",
    viewAllNotifications: "Ver todos los avisos →",
    emailPreferences: "Preferencias de email",
    logout: "Cerrar sesión",
  },
};
